import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

/**
 * Component used to display a loading state for a page.
 */
@Component({
    selector: 'generic-page-loading-state',
    imports: [TranslocoDirective],
    templateUrl: './generic-page-loading-state.component.html',
})
export class GenericPageLoadingStateComponent {}
